<template>
    <div class="approvalFlowConfigurationSearch">
        <Row :gutter="4">
            <div v-if="company==1">
                <Col span="4">
                    <Select v-model="companyId" filterable :placeholder="$t('configuration_management.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                        <Option value=" " selected>{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </div>
            <Col span="4">
                <Input search v-model="flowNameKey" :placeholder="$t('approvalFlowConfigManagement.approvalFlow.queryByFlowName')" @on-search="searchFlowName()"/>
            </Col>
            <Col span="4">
                <add-approval-flow-configuration></add-approval-flow-configuration>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddApprovalFlowConfiguration from '../approval_flow/AddApprovalFlowConfiguration'
    import TableApprovalFlowConfiguration from '../approval_flow/TableApprovalFlowConfiguration'
    var tableApprovalFlowConfiguration = TableApprovalFlowConfiguration;
    export default {
        name: 'ApprovalFlowConfigurationSearch',
        components: {
            AddApprovalFlowConfiguration
        },
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                flowNameKey:'',
                flowNameSearch:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            searchFlowName: function(){
                this.listApprovalFlow();
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
                this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                    .then(res => {
                        this.companyList = res.data;
                    });
            },
            // 按公司搜索
            searchCompany: function(){
                this.listApprovalFlow();
            },
            // 查询审批流列表
            listApprovalFlow: function () {
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                eventBus.$emit('flowNameSearch', this.flowNameKey);
                tableApprovalFlowConfiguration.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .approvalFlowConfigurationSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/approval_flow/ApprovalFlowConfigurationSearch.vue